module.exports = __webpack_public_path__ + "4d69ed3dbe0a1fd5f3e09a5aa808a98f.svg";